import { Component, h, Prop } from '@stencil/core';
import { PlatformCustomerPaymentMethod } from '@artask/tambr-models/models/customer.model';

@Component({
  tag: 'tambr-payment-method',
  styleUrl: 'tambr-payment-method.css',
  shadow: true
})
export class TambrPaymentMethod {

  @Prop() paymentMethod: PlatformCustomerPaymentMethod;

  componentWillLoad() {}

  expMonth() { 
    const month = this.paymentMethod.expMonth;
    return month < 10 ? `0${month}` : month;
  }

  isExpired() {
    return this.paymentMethod.expMonth < new Date().getMonth() 
      && this.paymentMethod.expYear <= new Date().getFullYear();
  }

  render() {
    return ([
      <div class="icon-wrapper">
        <tambr-icon class="brand-icon" type={ this.paymentMethod.brand } />
      </div>,
      <div class="info">
        <div class="number">
          { this.paymentMethod.brand } •••• •••• •••• { this.paymentMethod.last4 }
        </div>
        <div class={ 'expiration-date' + (this.isExpired() ? ' expired' : '') }>
          <span>{ this.isExpired() ? 'Expired ' : 'Expires ' }</span> 
          <span>{ this.expMonth() } / { this.paymentMethod.expYear }</span>
        </div>
      </div>
    ]);
  }
}
